export class Translator {
    public translateText(element: HTMLElement, key: string): string {
        if (!element) {
            throw new Error('Translator: Element is null or not defined');
        }

        const attributeName = `data-translation-${key}`;
        const translation = element.getAttribute(attributeName);

        if (translation === null || translation.trim() === '') {
            throw new Error(`Translator: Attribute '${attributeName}' not found.`);
        }

        return translation;
    }
}
